// import resume from '../assets/pdf/Bikash\'s Resume.pdf'
import resume from "../assets/pdf/Resume(BIKASH SHRESTHA).pdf";
import image from "../assets/images/bikash.jpg";

export const headerData = {
  name: "Bikash Shrestha",
  title: "Software Engineer",
  desciption:
  "There wasn't a bird in the sky, but that wasn't what caught my attention. It was the clouds — that deep, unnatural green that arrives just before a storm. I had learned to read that color. Six years of building software has taught me the same instinct: to notice the quiet signals before a system buckles, and to have the architecture, the tests, and the calm already in place when the load finally hits. I don't wait for the storm. I design for it.",
  // "There wasn't a bird in the sky, but that was not what caught my attention. It was the clouds. The deep green that isn't the color of clouds, but came with these. I knew what was coming and I hoped I was prepared. ",
  image: image,
  resumePdf: resume,
  resumePdfLink:
    "https://drive.google.com/file/d/1eJE9-m9mn8-E63ds3gTFQf7Evm9BSxbu/view?usp=drive_link",
};
